<template>
	<div id="app" :class="{
    'red-theme': isRedTheme
	}">
		<router-view v-if="isRouterAlive" />
		<baseCall></baseCall>
	</div>
</template>

<script>
import login from "./pages/login/Login";
import baseCall from '@/pages/baseCall/baseCall'
import '@/assets/css/common.less';
import '@/assets/css/table.css'
import {redStyleTp} from "@/js/constants";
export default {
	name: "App",
	components: {
		login,
		baseCall
	},
  computed: {
    isRedTheme () {
      return this.$store.state.styleTp === redStyleTp;
    }
	},
	data() {
		return {
			isRouterAlive: true
		}
	},
	provide() {
		return {
			reload: this.reload
		}
	},
	created() {
		// 在页面加载时读取sessionStorage
		if (sessionStorage.getItem("store")) {
			this.$store.replaceState(
				Object.assign(
					{},
					this.$store.state,
					JSON.parse(sessionStorage.getItem("store"))
				)
			);
		}
		// 在页面刷新时将store保存到sessionStorage里
		window.addEventListener("beforeunload", () => {
			sessionStorage.setItem("store", JSON.stringify(this.$store.state));
		});
	},
	methods: {
		reload() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
		watchEnter(e) {
			var key = window.event ? e.keyCode : e.which;
		},
	},
	mounted() {
		document.addEventListener('keydown', this.watchEnter);
	}
};
</script>
<style lang="less">
html {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	font-size: 16px;

	.el-table tr td {
		font-size: 15px !important;

	}
}

.amap-marker-label {
	background: none !important;
	border: none !important;
}

.transferView2 {
	.el-tabs__nav-wrap::after {
		background-color: rgba(228, 231, 237, .5)
	}

	.el-tree {
		background: transparent;
		color: #fff;
		min-height: 100%;
	}

	.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #2065b3 !important;
	}

	.el-tree-node__content:hover {
		background-color: #2065b3 !important;
	}

	.el-tabs__item {
		color: #fff !important;
	}

	.el-tree-node:focus>.el-tree-node__content {
		background-color: #2065b3 !important;
	}
}

.publicDialogTitle {
	.el-dialog__header {
		padding: 15px 20px;
		background-color: #177ecc;

		.el-dialog__title {
			color: #fff;
			letter-spacing: 1px;
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}
	}
}

.publicDialogTitleCwjd {
	.el-dialog__header {
		padding: 15px 20px;
		background-color: #177ecc;

		.el-dialog__title {
			color: #fff;
			letter-spacing: 1px;
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}
	}

	.el-dialog--center .el-dialog__body {
		padding: 0px
	}
}

.publicDialogTitlePeople {
	.el-dialog__header {
		padding: 15px 20px;
		background-color: #0081d5;

		.el-dialog__title {
			color: #fff;
			letter-spacing: 1px;
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}
	}

	.el-dialog__body {
		background: url("./assets/img/street/home-bg9027298.png") center center no-repeat #000133;
		background-size: 100% 100%;
		color: #fff;
	}
}

.el-dropdown-menu {
	z-index: 100001
}

.dianAnimat {
	position: relative !important;
	animation: mymove 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	-webkit-animation: mymove 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes mymove {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(255, 43, 15, 1.0);
	}

	25% {
		transform: scale(1);
		background: rgba(255, 43, 15, .85);
	}

	50% {
		transform: scale(2);
		background: rgba(255, 43, 15, .7);
	}

	75% {
		transform: scale(3.8);
		background: rgba(255, 43, 15, .5);
	}

	100% {
		transform: scale(3);
		background: rgba(255, 43, 15, .2);
	}
}

/*Safari and Chrome*/
@-webkit-keyframes mymove {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(255, 43, 15, 1.0);
	}

	25% {
		transform: scale(1);
		background: rgba(255, 43, 15, .85);
	}

	50% {
		transform: scale(2);
		background: rgba(255, 43, 15, .7);
	}

	75% {
		transform: scale(3.8);
		background: rgba(255, 43, 15, .5);
	}

	100% {
		transform: scale(3);
		background: rgba(255, 43, 15, .2);
	}
}

.dianAnimat1 {
	position: relative !important;
	animation: mymove 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	-webkit-animation: mymove 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes mymove {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(20, 255, 77, 1.0);
	}

	25% {
		transform: scale(1);
		background: rgba(20, 255, 77, .85);
	}

	50% {
		transform: scale(2);
		background: rgba(20, 255, 77, .7);
	}

	75% {
		transform: scale(3.8);
		background: rgba(20, 255, 77, .5);
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

/*Safari and Chrome*/
@-webkit-keyframes mymove {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(20, 255, 77, 1.0);
	}

	25% {
		transform: scale(1);
		background: rgba(20, 255, 77, .85);
	}

	50% {
		transform: scale(2);
		background: rgba(20, 255, 77, .7);
	}

	75% {
		transform: scale(3.8);
		background: rgba(20, 255, 77, .5);
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

.dianTitle {
	position: relative;
	animation: myTile 1.1s infinite;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	// animation-timing-function: ease-in-out; /*动画的速度曲线*/
	/* Safari 和 Chrome */
	// -webkit-animation:myTile 1.1s infinite;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	// -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}

@keyframes myTile {
	0% {
		opacity: 1;
		/*开始为原始大小*/
	}

	50% {
		opacity: 0
	}

	100% {
		opacity: 1;
		/*放大1.1倍*/
	}
}

/*Safari and Chrome*/
@-webkit-keyframes myTile {
	0% {
		opacity: 1;
		/*开始为原始大小*/
	}

	50% {
		opacity: 0
	}

	100% {
		opacity: 1
			/*放大1.1倍*/
	}
}

.waterInfoDialog {
	.el-dialog__header {
		padding: 0px;
		padding-top: 10px
	}

	.el-dialog__footer {
		padding-top: 0px
	}
}

.homeConciseTabs {
	text-align: center !important;
	display: block !important;

	.el-transfer-panel {
		width: 300px !important;
		text-align: left;

		.el-transfer-panel__body {
			height: 350px !important;

			.el-transfer-panel__list.is-filterable {
				height: 300px !important;
			}
		}
	}

	.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
		font-size: 12px;
	}
}

// 社区首页地图-水压
.homeMapMacker1 {
	position: relative !important;
	animation: homeMapMackerMymove1 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	animation: homeMapMackerMymove1 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes homeMapMackerMymove1 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(20, 255, 77, 1.0);
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

/*Safari and Chrome*/
@-webkit-keyframes homeMapMackerMymove1 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(20, 255, 77, 1.0);
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

// 社区首页地图-声光
.homeMapMacker2 {
	position: relative !important;
	animation: homeMapMackerMymove2 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	animation: homeMapMackerMymove2 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes homeMapMackerMymove2 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		// background: rgb(255, 55, 20);
		background: yellow;
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
		// background:yellow;
	}
}

// /*Safari and Chrome*/
@-webkit-keyframes homeMapMackerMymove2 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: yellow;
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

// 社区首页地图-智能烟感
.homeMapMacker3 {
	position: relative !important;
	animation: homeMapMackerMymove3 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	animation: homeMapMackerMymove3 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes homeMapMackerMymove3 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(174, 205, 237, 0.987);
	}

	100% {
		transform: scale(3);
		background: #b5d8e436;
	}
}

/*Safari and Chrome*/
@-webkit-keyframes homeMapMackerMymove3 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgba(174, 205, 237, 0.987);
	}

	100% {
		transform: scale(3);
		background: #b5d8e436;
	}
}

// 社区首页地图-智能手报
.homeMapMacker4 {
	position: relative !important;
	animation: homeMapMackerMymove4 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	animation: homeMapMackerMymove4 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes homeMapMackerMymove4 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgb(255, 145, 20);
	}

	100% {
		transform: scale(3);
		background: rgba(255, 145, 20, 0.189);
	}
}

/*Safari and Chrome*/
@-webkit-keyframes homeMapMackerMymove4 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgb(255, 145, 20);
	}

	100% {
		transform: scale(3);
		background: rgba(255, 145, 20, 0.189);
	}
}

// 社区首页地图-AI
.homeMapMacker5 {
	position: relative !important;
	animation: homeMapMackerMymove5 1.1s infinite !important;
	// animation-direction:alternate;/*轮流反向播放动画。*/
	animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
	/* Safari 和 Chrome */
	animation: homeMapMackerMymove5 1.1s infinite !important;
	// -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
	-webkit-animation-timing-function: ease-in !important;
	/*动画的速度曲线*/
}

@keyframes homeMapMackerMymove5 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgb(23, 142, 53);
	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}

/*Safari and Chrome*/
@-webkit-keyframes homeMapMackerMymove5 {
	0% {
		transform: scale(0.5);
		/*开始为原始大小*/
		background: rgb(23, 142, 53);

	}

	100% {
		transform: scale(3);
		background: rgba(20, 255, 77, .2);
	}
}.amap-logo{
    display: none;//去掉高德地图logo
}
.amap-copyright {
    opacity:0;//去掉高德的版本号
}

.amap-logo {
	display: none !important; //去掉高德地图logo
}

.amap-copyright {
	opacity: 0; //去掉高德的版本号
}</style>



// WEBPACK FOOTER //
// src/App.vue